import styled, { css, useTheme } from 'styled-components';
import { Icon } from '@elfsight/lib-icon';
import { COMMON_MOBILE_BREAKPOINT } from '@elfsight/lib-utils';
import { useLingui } from '@lingui/react/macro';
import { useSettings } from '@wu/widget-core';
import ScoreStub from '../../icons/score-stub.svg?react';
import { getNumericalScore } from '../../utils/get-numerical-score';
import { Block } from './block';
import { Gauge } from './gauge';

export function ScoreBlock() {
  const { t } = useLingui();
  const { auditReports, showAccessibilityInfo, showAccessibilityScore } =
    useSettings();
  const theme = useTheme();

  const report = auditReports.find(
    ({ isPending, isError }) => !(isPending || isError)
  );
  const score = report?.score ?? 0;

  const numericalScore = getNumericalScore(score);

  const applyScoreView = showAccessibilityScore && !!score;

  return (
    showAccessibilityInfo && (
      <StyledBlock>
        <Inner>
          {applyScoreView ? (
            <Gauge score={score} />
          ) : (
            <Icon
              component={ScoreStub}
              size={48}
              fill={theme.scoreBlock.iconColor}
              style={{ marginTop: 4 }}
            />
          )}

          <Content>
            <Title role="heading" aria-level={3}>
              {t`We Care About Accessibility`}
            </Title>
            <Caption>
              {applyScoreView
                ? t`We follow WCAG 2.1 AA guidelines and have a ${numericalScore}/100 site accessibility score, measured by Lighthouse.`
                : t`We aim to make our content accessible to everyone, regardless of ability.`}
            </Caption>
          </Content>
        </Inner>
      </StyledBlock>
    )
  );
}

const StyledBlock = styled(Block)`
  @media (max-width: ${COMMON_MOBILE_BREAKPOINT}px) {
    padding-inline: 0;
  }
`;

const Inner = styled.div`
  display: flex;
  gap: 12px;
  padding: 8px 12px;
`;

const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 4px;
    color: ${theme.scoreBlock.textColor};
  `}
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`;

const Caption = styled.div`
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  opacity: 0.7;
`;
